import React from 'react';
import PropTypes from 'prop-types';
import { formatDateTime } from '~/common';

const Changes = ({changes}) => {
    const getValue = (field, value) => {
        let result;
        if (field === 'datetime' || field === 'datetime_status') {
            result = formatDateTime(new Date(value));
        }
        else {
            result = JSON.stringify(value);
        }
        return result;
    };

    return (
        <ul className="clear">
            {Object.keys(changes).map((field, index) => {
                const o = changes[field].old;
                // noinspection JSUnresolvedVariable
                const n = changes[field].new;
                return (
                    <li key={index}>
                        <span className="name">{field}:</span>
                        <span className="old">{getValue(field, o)}</span>
                        <span className="new">{getValue(field, n)}</span>
                    </li>
                );
            })}
        </ul>
    );
};

Changes.propTypes = {
    changes: PropTypes.object,
};

export default Changes;
